import * as angular from 'angular';
import * as $ from 'jquery';

class PatientProfileNotesController {
  private showForm: boolean;
  private showList: boolean;
  private selectedFilter: any;
  private categories: any;
  private Users: any;
  private loadingPatientNotes: boolean | undefined;
  private showNoPreviousNotes: boolean | undefined;
  private patientNotes: any[] | undefined;
  private patientId: any;
  private saving: boolean | undefined;
  private Notifications: any;
  private textRequired: boolean | undefined;
  private user_note_id: null | undefined;
  private note: null | undefined;
  private selectedCat: string | undefined;
  private toastr: any;
  constructor($scope: any, toastr: any, Users: any, Notifications: any) {
    'ngInject';

    Object.assign(this, {
      $scope,
      toastr,
      Users,
      Notifications,
      patientId: parseInt($scope.ngDialogData.patient, 10),
      patientNote: $scope.ngDialogData.patientNote,
      textRequired: true,
      showForm: false,
      showList: false,
      showNoPreviousNotes: false,
      selectedFilter: "PMH",
      selectedCat: "PMH",
      note: null,
      user_note_id: null,

      categories: [
        { type : "PMH", description : "PMH"},
        { type : "patient support", description : "Patient Support"},
        { type : "general", description : "General"},
        { type : "pharmacy", description : "Pharmacy"},
        { type : "annual_gift", description : "Annual Member Gift"} ],

      categoriesFilter: [
        { type : "PMH", description : "PMH"},
        { type : "patient support", description : "Patient Support"},
        { type : "general", description : "General"},
        { type : "pharmacy", description : "Pharmacy"},
        { type : "annual_gift", description : "Annual Member Gift"},
        { type : "all", description : "All"} ],
    });


    // We do this to make the modal "movable or draggable"
    $scope.$on('ngDialog.opened', function () {
      // @ts-ignore
      $(".ngdialog-theme-default.pat-pro-notes").children(".ngdialog-content").draggable({

        handle: ".patient-profile-notes-popup"
      });
    });


    // We commented this because we are not supporting editing on this first version
    // To allow editing we just need to uncomment all this block "if - else"
    //
    //if (!this.patientNote) {

      // Search mode
      this.showForm = false;
      this.showList = true;
      this.search(this.selectedFilter);

    /*
    } else {

      // Edit mode
      this.showForm = true;
      this.showList = false;
      this.user_note_id = parseInt(this.patientNote.user_note_id, 10);
      this.note = this.patientNote.text;
      this.selectedCat = this.patientNote.type;
    }
    */
  }

  getDescCategory(type: any) {
    var typeDesc = "";
    this.categories.forEach((category: { type: any; description: string; }, j: any) => {
      if (category.type === type) {
        typeDesc = category.description;
      }
    });
    return typeDesc;
  }

  getFullName(id: any) {
    return new Promise((resolve, reject) => {
      this.Users.getOne(id)
      .then((data: { data: { firstname: string; lastname: string; }; }) => {
        resolve({ id: id, fullname: data.data.firstname + " " + data.data.lastname });
      })
      .catch((err: any) => {
        console.log(err);
        resolve({ id: id, fullname: ""});
      });
    });
  }

  filterClick() {
    // if (this.showForm) {
      this.showForm = false;
      this.showList = true;
      this.search(this.selectedFilter);
    // }
  }

  search(filter: string) {
    this.loadingPatientNotes = true;
    this.patientNotes = [];
    this.showNoPreviousNotes = false;

    var pagination = { limit: 999999 }

    this.Users.getPatientNotes(this.patientId, pagination)
    .then((data: { data: { data: any; }; }) => {

      var allPatientNotes = data.data.data;

      //console.log('Patient Notes', allPatientNotes);

      if (!allPatientNotes || allPatientNotes.length === 0) {

        this.showForm = false;
        this.showList = false;
        //this.addNote();
        this.showNoPreviousNotes = true;

      } else {

        allPatientNotes.sort(function(a: { modified: any; created: any; }, b: { modified: any; created: any; }) {
          var timestampA = (!a.modified ? a.created : a.modified);
          var timestampB = (!b.modified ? b.created : b.modified);
          return timestampB - timestampA;
        });

        allPatientNotes.forEach((patientNote: any) => {

          if (filter === "all" || filter === patientNote.type) {
            var timestamp = (!patientNote.modified ? patientNote.created : patientNote.modified);
            patientNote.date = new Date(timestamp * 1000);
            var title = (!patientNote.doctor.title ? "" : patientNote.doctor.title + " ");
            patientNote.fullname = title + patientNote.doctor.firstname + " " + patientNote.doctor.lastname;
            patientNote.typeDesc = this.getDescCategory(patientNote.type);
            // @ts-ignore
            this.patientNotes.push(patientNote);
          }
        });

        // @ts-ignore
        if (this.patientNotes.length === 0) {

          this.showForm = false;
          this.showList = false;
          //this.addNote();
          this.showNoPreviousNotes = true;
        }
      }
    })
    .catch((err: any) => { console.log(err);
    })
    .finally(() => { this.loadingPatientNotes = false; });
  }

  addNote() {
    this.showList = false;
    this.textRequired = false;
    this.user_note_id = null;
    this.note = null;
    this.selectedCat = "PMH";
    this.textRequired = true;
  }

  editNote(patientNote: any) {
    this.user_note_id = patientNote.user_note_id;
    this.note = patientNote.text;
    this.selectedCat = patientNote.type;
  }

  save() {
    this.saving = true;

    var data = { text: this.note, type: this.selectedCat };

    if (this.user_note_id) {
      this.Users.updatePatientNote(this.patientId, this.user_note_id, data)
      .then(() => {
        this.toastr.success(this.Notifications.patient.notes.success);
      })
      .catch((err: { status: number; }) => {
        if (err.status === 403) {
          this.toastr.error(this.Notifications.orders.locked);
        } else {
          this.toastr.error(this.Notifications.patient.notes.error);
        }
      })
      .finally(() => {
        this.saving = false;
        this.showForm = false;
        this.showList = true;
        this.search(this.selectedFilter);
      });

    } else {
      this.Users.createPatientNote(this.patientId, data)
      .then(() => {
        this.toastr.success(this.Notifications.patient.notes.success);
      })
      .catch((err: { status: number; }) => {
        if (err.status === 403) {
          this.toastr.error(this.Notifications.orders.locked);
        } else {
          this.toastr.error(this.Notifications.patient.notes.error);
        }
      })
      .finally(() => {
        this.saving = false;
        this.showForm = false;
        this.showList = true;
        this.search(this.selectedFilter);
      });
    }
  }
}

PatientProfileNotesController.$inject = ["$scope", "toastr", "Users", "Notifications"];
angular.module('pims').controller('PatientProfileNotesController', PatientProfileNotesController);
